module.exports = __webpack_public_path__ + "img/towel.16b1b32b.png";